import axios from 'axios';
import { getAuthToken } from '../../utils';
import USER_URL from './url';

export const getAllUsersItemsRequest = async (
  page: number,
  limit: number,
  isActive: boolean,
  name: string,
  roles: string,
  email: string,
) => {
  const token = getAuthToken();
  const response = await axios.get(
    `${USER_URL}?page=${page}&limit=${limit}&isActive=${isActive}&name=${name}&roles=${roles}&email=${email}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const disableUserRequest = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${USER_URL}/disable/${id}/`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};

export const enableUserRequest = async (id: string) => {
  const token = getAuthToken();
  const response = await axios.put(
    `${USER_URL}/enable/${id}/`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response.data;
};
